import React, { Component } from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import { Provider } from "react-redux";
import "./App.css";
// Styles
// CoreUI Icons Set
import "@coreui/icons/css/coreui-icons.min.css";
// Import Flag Icons Set
import "flag-icon-css/css/flag-icon.min.css";
// Import Font Awesome Icons Set
import "font-awesome/css/font-awesome.min.css";
// Import Simple Line Icons Set
import "simple-line-icons/css/simple-line-icons.css";
// Import Main styles for this application
import "./scss/style.css";

// Containers
// import { DefaultLayout } from './containers';

//Redux Store Initialization
import store from "./redux/store.js";

//Import Dashboard
// import Dashboard from './views/Dashboard/Dashboard'
// import TransporterTracker from './views/Transporter/Tracker/Tracker.jsx';
import TransporterTrackerA from "./views/Transporter/Tracker/TrackerDetails.jsx";
import DeliveryConfirmation from "./views/Transporter/DeliveryConfirmation/DeliveryConfirmation.jsx";
import DeliveryConfirmationID from "./views/Transporter/DeliveryConfirmation/ID-id/DeliveryConfirmation";
import WOPhotoUpload from "./views/Transporter/WOPhotoUpload";
import TransportedItemDatatable from "./views/Stocker/TransportedItemDatatable";
import Focus from "./views/Transporter/LiveTrackerExtn/Map";
import OpnameTaskExecution from "./views/Opname/OpnameTaskExecution/OpnameTaskExecution";
import TrackAndTrace from "./views/Transporter/TrackAndTraceTracker/";
// import { renderRoutes } from 'react-router-config';

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <HashRouter>
          <Switch>
            <Route
              path="/transporter/:id"
              name="Transporter Tracker"
              component={TransporterTrackerA}
              exact={true}
            />
            <Route
              path="/transporter"
              name="Transporter Tracker"
              component={TransporterTrackerA}
              exact={true}
            />
            <Route
              path="/transporter/live-share/:company/:key/"
              name="Live Monitoring Share"
              component={Focus}
              exact={true}
            />
            <Route
              path="/delivery/:id"
              name="Transporter Delivery Conformation"
              component={DeliveryConfirmation}
              exact={true}
            />
            <Route
              path="/delivery"
              name="Transporter Delivery Conformation"
              component={DeliveryConfirmation}
              exact={true}
            />

            <Route
              path="/delivery-id/:id"
              name="Transporter Delivery Conformation"
              component={DeliveryConfirmationID}
              exact={true}
            />
            <Route
              path="/delivery-id/"
              name="Transporter Delivery Conformation"
              component={DeliveryConfirmationID}
              exact={true}
            />

            <Route
              path="/proofofdelivery/:key"
              name="Transporter WO Photo Upload"
              component={WOPhotoUpload}
              exact={true}
            />
            <Route
              path="/proofofdelivery/"
              name="Transporter WO Photo Upload"
              component={WOPhotoUpload}
              exact={true}
            />
          <Route
              path="/trackandtrace/:company/:bucket/:id"
              name="Track And Trace"
              component={TrackAndTrace}
              exact={true}
            />
            <Route
              path="/stocker/:key/:id_outbound"
              name="Transported Item List"
              component={TransportedItemDatatable}
              exact={true}
            />
            <Route
              path="/opname/task-execution/:key/:id"
              name="Opname Task Execution"
              component={OpnameTaskExecution}
              exact={true}
            />
            <Redirect from="/" to="/transporter" />
            {/* <Route path="/transporter/:id" name="Transporter Tracker" component={TransporterTracker} /> */}
            {/* <Route path="/" name="Home" component={DefaultLayout} /> */}
            {/* <Route path="/" name="Dashboard" component={Dashboard} /> */}
          </Switch>
        </HashRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js